// 時間軸段落標題：大字（月份數字、Q4、年份、TBA、本週起始日）＋標籤、副標（含數量）。
// 桌面放在左欄並跟著捲動；平板與手機放在內容上方（版面由 CSS 決定）。
import { memo } from 'react';
import type { SectionHeader } from '../../filters/catalog.ts';
import { t } from '../../i18n/zh-TW.ts';
import { sectionText } from '../../lib/format.ts';

export const GroupHeader = memo(function GroupHeader({ header }: { header: SectionHeader }) {
  const { big, label, sub, full } = sectionText(header);
  // 月份的副標已經寫出確定／只到月份的數量，其他段落補上總數
  const subLine = header.section.kind === 'month' ? sub : `${sub} · ${t.group.count(header.count)}`;
  const soon = header.section.kind === 'week' || header.section.kind === 'next-week';
  return (
    <h2 className={soon ? 'group-header group-soon' : 'group-header'} data-label={full}>
      <span className="sr-only">
        {full}，{t.group.count(header.count)}
      </span>
      <span className="gh-big num" aria-hidden="true">
        {big}
      </span>
      <span className="gh-text" aria-hidden="true">
        <span className="gh-label">{label}</span>
        <span className="gh-sub">{subLine}</span>
      </span>
    </h2>
  );
});
